import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ZoomIn, X, Phone } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import flyer1 from "../assets/flyer1.png";
import flyer2 from "../assets/flyer2.png";

const Speisekarte = () => {
  const [zoomed, setZoomed] = useState(null);

  const flyers = [
    { src: flyer1, label: "Vegetarisch · Vegan · Getränke · Spar Menü · Kontakt" },
    { src: flyer2, label: "Döner · Lahmacun · Pide · Pizza · Salate" },
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />

      <section className="pt-28 pb-16 px-6" data-testid="speisekarte-page">
        <div className="max-w-7xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/60 hover:text-red-500 mb-8 uppercase tracking-widest text-sm transition-colors"
            data-testid="back-home-btn"
          >
            <ArrowLeft size={16}/> Zurück zur Startseite
          </Link>

          <div className="text-center mb-12">
            <div className="handwritten text-red-500 text-xl mb-3">— Alle Gerichte auf einen Blick</div>
            <h1 className="display text-5xl md:text-7xl font-bold">
              UNSERE <span className="text-red-600">SPEISEKARTE</span>
            </h1>
            <p className="text-white/60 max-w-2xl mx-auto mt-6">
              Tippen Sie auf eine Seite, um sie in voller Größe zu sehen.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {flyers.map((f, i) => (
              <div key={i} className="group relative" data-testid={`flyer-card-${i + 1}`}>
                <button
                  onClick={() => setZoomed(f.src)}
                  className="block w-full border-2 border-red-600/30 hover:border-red-600 overflow-hidden relative bg-neutral-900"
                  data-testid={`flyer-zoom-btn-${i + 1}`}
                >
                  <img src={f.src} alt={`Speisekarte Seite ${i + 1}`} className="w-full h-auto block group-hover:scale-[1.02] transition-transform duration-500"/>
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                    <div className="bg-red-600 text-white px-6 py-3 uppercase tracking-widest font-bold flex items-center gap-2">
                      <ZoomIn size={18}/> Vergrößern
                    </div>
                  </div>
                </button>
                <div className="mt-3 text-center text-white/70 text-sm uppercase tracking-widest">
                  Seite {i + 1} — {f.label}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center p-10 border border-red-600/30 bg-red-600/5">
            <h3 className="display text-3xl mb-3">HUNGRIG? <span className="text-red-600">Jetzt bestellen!</span></h3>
            <p className="text-white/60 mb-6">Rufen Sie uns an oder schreiben Sie uns auf WhatsApp.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:+4971175486846" className="px-8 py-4 bg-red-600 hover:bg-red-700 uppercase tracking-widest font-bold inline-flex items-center justify-center gap-2" data-testid="order-call-btn">
                <Phone size={18}/> 0711 75486846
              </a>
              <a href="https://wa.me/4916321479581" target="_blank" rel="noreferrer" className="px-8 py-4 border-2 border-white/30 hover:border-red-600 hover:bg-red-600/10 uppercase tracking-widest font-bold inline-flex items-center justify-center gap-2" data-testid="order-whatsapp-btn">
                WhatsApp 0163 2147958
              </a>
            </div>
          </div>
        </div>
      </section>

      {zoomed && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-sm flex items-center justify-center p-4 overflow-auto"
          onClick={() => setZoomed(null)}
          data-testid="flyer-lightbox"
        >
          <button
            onClick={() => setZoomed(null)}
            className="fixed top-6 right-6 z-10 bg-red-600 hover:bg-red-700 text-white p-3 rounded-full"
            data-testid="lightbox-close-btn"
          >
            <X size={24}/>
          </button>
          <img src={zoomed} alt="Speisekarte vergrößert" className="max-w-full max-h-full object-contain" onClick={(e) => e.stopPropagation()}/>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Speisekarte;
